var $9f18aee5ddbe5e0f$exports = {};
$9f18aee5ddbe5e0f$exports = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


export {$9f18aee5ddbe5e0f$exports as default};
//# sourceMappingURL=he-IL.mjs.map
